module.exports = __webpack_public_path__ + "static/media/bgWelcomeFooter_.d2ad2976.jpg";